import React from 'react';
import Image from 'next/image';
import Skeleton from 'react-loading-skeleton';

import { SliderContainer } from '../../common';
import Button from '../Button/Button';

import styles from './OurManagement.module.scss';

const sliderOptions1 = {
  slidesToShow: 1,
  infinite: true,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        arrows: false,
      },
    },
  ],
};

const OurManagement = ({ data }) => {
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  const renderManagerCard = (item) => {
    return (
      <div
        className={styles.background}
        itemScope
        itemType='https://schema.org/Organization'
      >
        <div className={styles.container}>
          <div className={styles.imageWrapper}>
            {!isImageLoaded && (
              <Skeleton width={250} height={250} className={styles.skeleton} />
            )}
            <Image
              src={item?.image}
              width={670}
              height={670}
              alt={item.name}
              title={item.name}
              onLoadingComplete={() => setIsImageLoaded(true)}
              style={{
                visibility: isImageLoaded ? 'visible' : 'hidden',
              }}
            />
          </div>
          <div>
            <div className={styles.title}>{item.title}</div>
            <div className={styles.name}>{item.name}</div>
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: item.description }}
            />
            {item?.button_text && item?.button_slug && (
              <Button
                size='normal'
                variant='outline'
                Component='router'
                href={item?.button_slug}
                className={styles.managment_btn}
              >
                {item?.button_text}
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  };
  return data?.items?.length >= 2 ? (
    <SliderContainer
      title={data?.title}
      icon={data?.icon}
      addClass={styles.bannerSlider}
      options={sliderOptions1}
    >
      {data?.items?.map(renderManagerCard)}
    </SliderContainer>
  ) : (
    <div className='section'>{data?.items?.map(renderManagerCard)}</div>
  );
};

export default OurManagement;
